// Tiny DOM helpers -- no framework. ASCII only.

/**
 * Create an element. `attrs` may include text, html, class, on<Event> handlers,
 * dataset.*, and any attribute. `children` is a node or array of nodes/strings.
 */
export function el(tag, attrs = {}, children = []) {
  const node = document.createElement(tag);
  for (const [k, v] of Object.entries(attrs)) {
    if (v == null) continue;
    if (k === 'class') node.className = v;
    else if (k === 'text') node.textContent = v;
    else if (k === 'html') node.innerHTML = v;
    else if (k === 'dataset') Object.assign(node.dataset, v);
    else if (k === 'muted') {
      // Setting the muted ATTRIBUTE after createElement only sets defaultMuted;
      // the element still plays. Every self-view here is a live microphone, so
      // getting this wrong means the user hears themselves. Set the property.
      node.muted = v !== false;
      node.setAttribute('muted', ''); // and keep the attribute for autoplay policies
    }
    else if (k.startsWith('on') && typeof v === 'function') {
      node.addEventListener(k.slice(2).toLowerCase(), v);
    } else if (k === 'aria') {
      for (const [ak, av] of Object.entries(v)) node.setAttribute(`aria-${ak}`, av);
    } else {
      node.setAttribute(k, v);
    }
  }
  const kids = Array.isArray(children) ? children : [children];
  for (const c of kids) {
    if (c == null) continue;
    node.append(c.nodeType ? c : document.createTextNode(String(c)));
  }
  return node;
}

export function clear(node) {
  while (node.firstChild) node.removeChild(node.firstChild);
}

export function mount(root, node) {
  clear(root);
  root.append(node);
}

let toastTimer = null;
export function toast(message, ms = 2600) {
  let t = document.querySelector('.toast');
  if (!t) {
    t = el('div', { class: 'toast', role: 'status' });
    document.body.append(t);
  }
  t.textContent = message;
  // Force reflow so the transition runs even on repeat calls.
  void t.offsetWidth;
  t.classList.add('show');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => t.classList.remove('show'), ms);
}

/** The Lumi orb logo as an inline SVG string. */
export const ORB_SVG = `
<svg viewBox="0 0 64 64" class="logo" aria-hidden="true">
  <defs>
    <radialGradient id="lumiOrb" cx="38%" cy="32%" r="75%">
      <stop offset="0%" stop-color="#A78BFA"/>
      <stop offset="55%" stop-color="#8B5CF6"/>
      <stop offset="100%" stop-color="#06B6D4"/>
    </radialGradient>
  </defs>
  <path d="M32 13 a19 19 0 1 1 -13.4 32.4 L13 50 l2.1 -7.2 A19 19 0 0 1 32 13 z" fill="url(#lumiOrb)"/>
  <circle cx="25.5" cy="25.5" r="3.2" fill="#FB7185" opacity="0.92"/>
</svg>`;
